import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { gql } from '@apollo/client'
import { Button, Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { LETTER_SEARCH_QUERY } from '../../../graphql.js'
import '../Custom.css'
import { csvUrl, getData } from '../CustomUtils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'

const LETTER_SEARCH = gql(LETTER_SEARCH_QUERY)

export default function LetterSearch(props) {
  console.log('LetterSearch rendered:', props)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    getData(location, LETTER_SEARCH, 'letterSearch', setResults, setGraphQLErrors)
  }, [location])

  function viewButtonClicked(objectId) {
    const url = `/object/${objectId}?source=${location.pathname}${location.search}`
    navigate(url)
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const columnHeadings =
      <tr>
        <th>Date</th>
        <th>Company/Site/Vessel</th>
        <th>Location</th>
        <th>Plaintiff</th>
        <th>Overall Contract Number</th>
        <th>Contract Letter Type</th>
        <th>File Name 1</th>
        <th>Document Type</th>
        <th>Station, Refinery, Mill, Ect.</th>
        <th></th>
      </tr>

    const resultRows = []
    for (let i = 0; i < results.length; i++) {
      let row = []
      for (let j = 0; j < results[i].length; j++) {
        if (j === results[i].length - 1) {
          row.push(<td key={j}><Button className={results[i][j]} onClick={() => viewButtonClicked(results[i][j])} color="primary" size="sm">View</Button></td>)
        } else {
          row.push(<td key={j}>{results[i][j]}</td>)
        }
      }
      resultRows.push(<tr key={i}>{row}</tr>)
    }

    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Custom/letterSearch/letter_search', location)} resultsLength={results.length} />
        </div>
        <Table bordered className="custom-table">
          <ReportHeading title={'Contract and Production Transmittal Letters'} widths={['0%', '100%', '0%']} showReportDate={false} />
          {columnHeadings}
          <tbody>
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}